import { parser , createForm } from '../format/form'

export default {
  data(){
    return {
      form:null,
    }
  },

  created(){
    if(this.formData){
      this.formData = parser(this.formData)
    }
    this.$watch('visible' , function(v){
      if(v === false){
        this.$resetFormData()
      }
    })
    this.__updateForm()
  },
  mounted(){
    this.__updateForm()
  },
  render(){
    this.__updateForm()
  },
  methods:{
    __updateForm(){
      if(!this.form) {
        this.form = createForm(this)
      }
    },
    reset() {
      this.params = {}
      this.search()
    },
    $setFormData(data , save = false , forceUpdate = false){
      let validFields = {}
      for(let key in this.formData){
        if(key in data){
          validFields[key] = data[key]
        }
      }
      if(save) this._last_data = {...validFields}
      if(!this._origin_data) this._origin_data = {...validFields}
      this.$nextTick(()=>{
        
        this.form.setFieldsValue(validFields)
        //如果存在延迟加载的 formitem 需强制更新
        if(forceUpdate) this.$forceUpdate();
      })
    },
    $handleSubmit(){
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$save(values)
        }else{
          this.$Message.error('请按要求填写(选择)内容');
        }
      });
    },
    $resetFormData(restore){
      //if( this._origin_data ){
      let data = restore ? this._last_data : null
      this.form.resetFields(data) 
      //}
    },

    $save(data) {
      if(typeof this.save == 'function'){
        return this.save(data)
      }
      
      let params = { ...data }

      if(typeof this.beforeSave == 'function'){
        params = this.beforeSave(params)
        if(params === false) return
      }else{
        if(this.id){
          params.id = this.id
        }
      }

      let promise
      if(this.api){
        if(typeof this.api == 'string'){
          promise = this.$request[this.api]
        }
        else{
          promise = this.id ? this.$request[this.api[1]] : this.$request[this.api[0]]
        }
      }else if( typeof this.getApi == 'function'){
        promise = this.getApi(data)
      }

      if(promise){
        this.loading = true
        promise(params).then(resp => {
          if(typeof this.afterSave == 'function'){
            this.afterSave(resp)
          }else{
            if (resp.code) {
              this.$Message.error( resp.msg )
            } else {
              this.$Message.success('保存成功')
              this.$emit('update')
              this.visible = false
            }
            this.loading = false
          }
        })
      }
    }
  }
}